import styled from "@emotion/styled";

import { sizeToken } from "../../../Internals/ThemeProvider/CandyTheme/ThemeBuilder/ICandyTheme";
import {
    reactUiModalLeftPadding,
    reactUiModalRightPadding,
} from "../../../Internals/ThemeProvider/ReactUiModalPaddings";

export const TemplatesList = styled.div({
    width: 500,
    margin: `0 -${reactUiModalRightPadding}px 0 -${reactUiModalLeftPadding}px`,
});

export const LoadingBlock = styled.div({
    margin: `0 -${reactUiModalRightPadding}px 0 -${reactUiModalLeftPadding}px`,
    width: 500,
    height: 69,
});

export const EmptyListMessage = styled.div({
    padding: `${sizeToken(0.5)}px ${reactUiModalRightPadding}px ${sizeToken(0.5)}px ${reactUiModalLeftPadding}px`,
});

export const ErrorMessage = styled.div({
    width: 500 - reactUiModalRightPadding - reactUiModalLeftPadding,
    height: 69,
});

export const CreateTemplate = styled.div({
    padding: `${sizeToken(0.5)}px ${reactUiModalRightPadding}px ${sizeToken(0.5)}px ${reactUiModalLeftPadding}px`,
    lineHeight: `32px`,
});
